import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200/70 pt-16 md:pt-20 pb-8">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-16">
          <div>
            <h4 className="font-semibold text-sm text-foreground-900 mb-4">Categories</h4>
            <div className="w-8 h-0.5 bg-accent-500 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap"
                >
                  {cat.displayName}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-900 mb-4">Guides</h4>
            <div className="w-8 h-0.5 bg-accent-500 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <Link to="/superbuy-spreadsheet-beginner-guide" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Beginner Guide
              </Link>
              <a href="#safety" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Safety Guide
              </a>
              <a href="#resources" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                QC Photo Guide
              </a>
              <a href="#categories" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Shopping Workflow
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-900 mb-4">Safety</h4>
            <div className="w-8 h-0.5 bg-accent-500 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <a href="#safety" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Buyer Protection
              </a>
              <a href="#safety" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Link Verification
              </a>
              <a href="#safety" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                QC Guidelines
              </a>
              <a href="#safety" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Payment Security
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-900 mb-4">Resources</h4>
            <div className="w-8 h-0.5 bg-accent-500 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <Link to="/superbuy-spreadsheet-beginner-guide" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Spreadsheet Guide
              </Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Main Platform
              </a>
              <a href="#categories" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Product Categories
              </a>
              <a href="#resources" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">
                Comparison Tools
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-200/50 pt-10 pb-4">
          <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
            <div>
              <h3 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-none">
                Superbuy
              </h3>
              <h3 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-none mt-1">
                Spreadsheet
              </h3>
              <div className="w-12 h-0.5 bg-accent-500 mt-4 mb-2"></div>
              <p className="text-xs text-foreground-400">
                The authority resource for smarter shopping.
              </p>
            </div>

            <div className="flex flex-col items-start md:items-end gap-4">
              <div className="flex items-center gap-4">
                <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 text-foreground-500 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 text-foreground-500 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-pinterest-line text-sm"></i>
                </a>
                <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 text-foreground-500 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-reddit-line text-sm"></i>
                </a>
                <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 text-foreground-500 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-youtube-line text-sm"></i>
                </a>
              </div>
              <p className="text-xs text-foreground-400">
                &copy; {new Date().getFullYear()} superbuyspread.yachts
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}